/* Libraries */
import React, { useCallback, useMemo, useRef, useEffect } from 'react';

/* Hooks */
import useMst from '~/src/hooks/useMst';
import { useObserver } from 'mobx-react';
import useTemplateDefaultValuesListActions from '~/src/hooks/useTemplateDefaultValuesListActions';

/* Components */
import { TemplateDefaultValuesListWrapper } from '~/src/components/TemplateDefaultValuesList';
import { TOTAL_DOCUMENT_LIMIT } from '../utils/constants';

const TemplateDefaultValuesListContainer = () => {
  const {
    sidebarItemTotalNumber,
    containedInSidebarStore,
    addFormTemplateToSelectionSidebar,
  } = useMst((store) =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useObserver(() => ({
      sidebarItemTotalNumber: store.sidebarItems.items.length,
      containedInSidebarStore: store.sidebarItems.containedInSidebar,
      addFormTemplateToSelectionSidebar:
        store.templateDefaultValues.addFormTemplateToSelectionSidebar,
    })),
  );

  // Store the latest function reference to avoid recreation
  const containedInSidebarStoreRef = useRef(containedInSidebarStore);

  useEffect(() => {
    containedInSidebarStoreRef.current = containedInSidebarStore;
  }, [containedInSidebarStore]);

  const containedInSidebar = useCallback((templateDefaultValues) => {
    return containedInSidebarStoreRef.current(templateDefaultValues);
  }, []);

  const {
    rename,
    delete: handleDelete,
    duplicate,
    edit,
  } = useTemplateDefaultValuesListActions();

  const rowActions = useMemo(
    () => ({
      rename,
      delete: handleDelete,
      duplicate,
      edit,
    }),
    [rename, handleDelete, duplicate, edit],
  );

  return (
    <TemplateDefaultValuesListWrapper
      addFormTemplateToSelectionSidebar={addFormTemplateToSelectionSidebar}
      containedInSidebar={containedInSidebar}
      rowActions={rowActions}
      sidebarItemTotalNumber={sidebarItemTotalNumber}
      sidebarItemTotalNumberLimit={TOTAL_DOCUMENT_LIMIT}
    />
  );
};

export default TemplateDefaultValuesListContainer;
